import React, { useState, useEffect } from "react";
import "../../assets/styles/global.css";
import { FaTimes } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

function MobileMenu() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // إغلاق القائمة عند تغيير الصفحة
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // دالة للانتقال إلى الصفحة الرئيسية ثم السكروول
  const goToSection = (sectionId) => {
    if (location.pathname !== "/") {
      window.location.href = `/#${sectionId}`;
    } else {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
    setOpen(false);
  };

  return (
    <>
      <div className="mobile-menu-icon" onClick={() => setOpen(true)}>
        ☰
      </div>

      <div className={`mobile-menu ${open ? "open" : ""}`}>
        <div className="close-btn" onClick={() => setOpen(false)}>
          <FaTimes size={28} />
        </div>

        <button onClick={() => goToSection("home")}>الرئيسية</button>
        <button onClick={() => goToSection("services")}>الخدمات</button>
        <button onClick={() => goToSection("gallery")}>المعرض</button>
        <button onClick={() => goToSection("contact")}>تواصل معنا</button>

        <Link to="/about" onClick={() => setOpen(false)}>من نحن</Link>
      </div>
    </>
  );
}

export default MobileMenu;
